import { render, staticRenderFns } from "./CompareCostsTable.vue?vue&type=template&id=78d7a5b6&scoped=true&"
import script from "./CompareCostsTable.vue?vue&type=script&lang=js&"
export * from "./CompareCostsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d7a5b6",
  null
  
)

export default component.exports